import { Checkbox, Form } from 'antd';
import React from 'react';

const ModerationCheckboxes = () => {
  return (
    <>
      <Form.Item
        name="newsModerator"
        valuePropName="checked"
        style={{ marginBottom: 0 }}
        wrapperCol={{ offset: 8, span: 16 }}
      >
        <Checkbox> Модератор новостей</Checkbox>
      </Form.Item>
      <Form.Item
        name="pollModerator"
        valuePropName="checked"
        style={{ marginBottom: 0 }}
        wrapperCol={{ offset: 8, span: 16 }}
      >
        <Checkbox> Модератор опросов</Checkbox>
      </Form.Item>
      <Form.Item
        name="faqModerator"
        valuePropName="checked"
        style={{ marginBottom: 0 }}
        wrapperCol={{ offset: 8, span: 16 }}
      >
        <Checkbox>Модератор часто задаваемых вопросов</Checkbox>
      </Form.Item>
    </>
  );
};

export default ModerationCheckboxes;
